import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Flights from './pages/Flights';
import Hotels from './pages/Hotels';
import Cars from './pages/Cars';
import Deals from './pages/Deals';
import Destinations from './pages/Destinations';
import Blog from './pages/Blog';
import About from './pages/About';
import NotFound from './pages/NotFound';
import Privacy from './pages/legal/Privacy';
import Terms from './pages/legal/Terms';
import Cookies from './pages/legal/Cookies';
import AffiliateDisclosure from './pages/legal/AffiliateDisclosure';
import PriceDisclaimer from './pages/legal/PriceDisclaimer';
import ProviderDisclaimer from './pages/legal/ProviderDisclaimer';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="flights" element={<Flights />} />
            <Route path="hotels" element={<Hotels />} />
            <Route path="cars" element={<Cars />} />
            <Route path="deals" element={<Deals />} />
            <Route path="destinations" element={<Destinations />} />
            <Route path="blog" element={<Blog />} />
            <Route path="about" element={<About />} />
            <Route path="privacy" element={<Privacy />} />
            <Route path="terms" element={<Terms />} />
            <Route path="cookies" element={<Cookies />} />
            <Route path="affiliate-disclosure" element={<AffiliateDisclosure />} />
            <Route path="price-disclaimer" element={<PriceDisclaimer />} />
            <Route path="provider-disclaimer" element={<ProviderDisclaimer />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
